export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7755.af3aafc0.jpg";